import { checkAuth } from '@/utils/permission'

function apply(el, binding) {
  if (checkAuth(binding.value, binding.arg)) return
  if (el.parentNode) {
    el.parentNode.removeChild(el)
  } else {
    el.style.display = 'none'
  }
}

export default {
  inserted: apply
}
